import { FC } from 'react';
import { useMutation } from '@apollo/client';
import { AzureUpload } from './azure-upload';
import { ApplicantSharedFileUploadProcessMaliciousFileScanDocument } from '../../../generated';

// Accept all AzureUpload props except runMalwareScan (provided internally)
export type AzureUploadContainerProps = Omit<React.ComponentProps<typeof AzureUpload>, 'runMalwareScan'>;

export const AzureUploadContainer: FC<AzureUploadContainerProps> = (props) => {
  const [executeMalwareScan] = useMutation(ApplicantSharedFileUploadProcessMaliciousFileScanDocument);

  const runMalwareScanHandler = async (blobUrl: string, versionId: string) => {
    try {
      const { data } = await executeMalwareScan({
        variables: {
          input: {
            blobUrl,
            versionId,
            maxTimeoutMs: 60000,
            initialDelay: 1000,
          }
        },
      });
      const result = data?.processMaliciousFileScan;
      return {
        isSafe: !!result?.isSafe,
        isMalicious: !!result?.isMalicious,
        scanResult: result?.scanResult || undefined,
      };
    } catch (e) {
      console.warn('[AzureUploadContainer] mutation error', e);
      return { isSafe: false, isMalicious: false };
    }
  };

  return <AzureUpload {...props} runMalwareScan={runMalwareScanHandler} />;
};